import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import type { ChildRouteContext } from "@/root";

import ObjectiveForm from "@/modules/performance/user/components/objective/form/ObjectiveForm";
import { fetchObjectiveQueryOptions } from "@/modules/performance/user/services";

export const Route = createFileRoute(
  "/_panel/_performance/performance/objectives/edit/$id",
)({
  component: RouteComponent,
  parseParams: (params) => ({
    id: z.number().int().parse(Number(params.id)),
  }),
  beforeLoad: ({ context }) =>
    ({
      crumb: [
        {
          label: context.t("Edit Objective", { ns: "performance.user" }),
        },
      ],
    }) satisfies ChildRouteContext,
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      fetchObjectiveQueryOptions(opts.params.id),
    ),
  stringifyParams: ({ id }) => ({ id: `${id}` }),
});

function RouteComponent() {
  const { id } = Route.useParams();

  return <ObjectiveForm id={id} />;
}
